:host {
  cursor: pointer;
}

.select-arrows {
  margin-left: 0.25em;
}
